const buildSelectedItemsMap = (pages, folders, prevMap = {}) => {
  const map = {};

  pages.forEach((page) => {
    map[page.id] = prevMap[page.id] ?? false;
  });
  folders.forEach((folder) => {
    map[folder.id] = prevMap[folder.id] ?? false;
  });

  return map;
};

export default buildSelectedItemsMap;
